export enum CreditUsageType {
  CONTACT_STORAGE_BASIC = 'CONTACT_STORAGE_BASIC',
  ACCOUNT_STORAGE_BASIC = 'ACCOUNT_STORAGE_BASIC',
  ACCOUNT_STORAGE_AI = 'ACCOUNT_STORAGE_AI',
  CONTACT_STORAGE_AI = 'CONTACT_STORAGE_AI',
  CONTACT_ANALYSIS_REVEAL = 'CONTACT_ANALYSIS_REVEAL',
  CONTACT_PROFILE_REVEAL = 'CONTACT_PROFILE_REVEAL',
  CONTACT_EMAIL_FINDING = 'CONTACT_EMAIL_FINDING',
  CONTACT_ANALYSIS_UPDATE = 'CONTACT_ANALYSIS_UPDATE',
  CONTACT_PROFILE_UPDATE = 'CONTACT_PROFILE_UPDATE',
  CONTACT_EMAIL_REVERIFICATION = 'CONTACT_EMAIL_REVERIFICATION',
  CONTACT_PHONE_FINDING = 'CONTACT_PHONE_FINDING',
  ACCOUNT_STORAGE_ENRICH = 'ACCOUNT_STORAGE_ENRICH',
  CONTACT_STORAGE_ENRICH = 'CONTACT_STORAGE_ENRICH',
  CONTACT_JOB_CHANGE = 'CONTACT_JOB_CHANGE',
  CONTACT_ENRICH_EMAIL = 'CONTACT_ENRICH_EMAIL',
}

export interface CreditUsage {
  credit: number;
  title: string;
  type: CreditUsageType;
}
